import { Endpoint } from "./config";
import { EndpointType } from "./types";
import { authEndpoints } from "./modules/auth";
import { staffEndpoints } from "./modules/staff";
import { rolesEndpoints } from "./modules/roles";
import { lienEndpoints } from "./modules/lien";
import { dashboardEndpoints } from "./modules/dashboard";
import { filesEndpoints } from "./modules/files";
import { notificationsEndpoints } from "./modules/notifications";
import { auditEndpoints } from "./modules/audit";
import { systemEndpoints } from "./modules/system";
import { profileEndpoints } from "./modules/profile";

export * from "./config";
export * from "./types";
export * from "./modules/auth";
export * from "./modules/staff";
export * from "./modules/roles";
export * from "./modules/lien";
export * from "./modules/dashboard";
export * from "./modules/files";
export * from "./modules/profile";

export const endpoints: Record<EndpointType, Endpoint> = {
  ...authEndpoints,
  ...staffEndpoints,
  ...rolesEndpoints,
  ...lienEndpoints,
  ...dashboardEndpoints,
  ...filesEndpoints,
  ...notificationsEndpoints,
  ...auditEndpoints,
  ...systemEndpoints,
  ...profileEndpoints,
};
